import { render, staticRenderFns } from "./GetStarted.vue?vue&type=template&id=87ad3214&scoped=true"
import script from "./GetStarted.vue?vue&type=script&lang=js"
export * from "./GetStarted.vue?vue&type=script&lang=js"
import style0 from "./GetStarted.vue?vue&type=style&index=0&id=87ad3214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ad3214",
  null
  
)

export default component.exports